<!-- eslint-disable -->
<template lang="pug">
    cs-modal(@close="$emit('close')")
        .confirm-delete__header(slot='header')
            | {{ $i18n.t('modal.modal_confirmDelete_confirmation') }}
        | {{ $i18n.t('modal.modal_confirmDelete_agreement') }}
        slot
        | ?
        .modal-buttons
            cs-button.modal-buttons__yes(type="button", @click="$emit('delete')", color="green") {{ $i18n.t('common.common_button_yes') }}
            cs-button.modal-buttons__no(type="button", @click="$emit('close')", color="orange") {{ $i18n.t('common.common_button_no') }}
</template>

<script>
    /*eslint-disable*/
    import CsModal from '../elements/CsModal.vue';

    export default {
        components: {
            CsModal,
        }
    }
</script>

<style lang="scss">
    .confirm-delete__header {
        margin-bottom: 20px;
    }
    .modal-buttons {
        margin-top: 20px;
    }
    .modal-buttons__yes {
        margin-right: 20px;
    }
</style>

